import React, { useState, useEffect } from 'react';
import customCSS from './Allpayments.module.css';
import ENV from '../../constants/env-constants';
import { useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';

function Contactforms() {
  const [formEntries, setFormEntries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const location = useLocation()

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Admin All-Forms Page' });
    fetch(`${ENV.API_URL}/api/viewforms`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      setFormEntries(data); 
    })
    .catch(error => {
      console.error('Fetch error:', error);
    });
  }, []);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = formEntries.slice(indexOfFirstRow, indexOfLastRow);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(formEntries.length / rowsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Contact-Forms</title>
        </Helmet>
        <div className={`layout-container ${customCSS.maincontainer}`}>
          <h1 className={customCSS.heading}>Contact Form Entries</h1>
          <div className={customCSS.layoutWrapper}>
            <table className={customCSS.table}>
              <thead>
                <tr>
                  <th className={customCSS.th}>First Name</th>
                  <th className={customCSS.th}>Last Name</th>
                  <th className={customCSS.th}>Email</th>
                  <th className={customCSS.th}>Phone Number</th>
                  <th className={customCSS.th}>Country</th>
                  <th className={customCSS.th}>Company/Organization</th>
                  <th className={customCSS.th}>Comments</th>
                </tr>
              </thead>
              <tbody>
                {currentRows.map((entry, index) => (
                  <tr key={index}>
                    <td className={customCSS.td}>{entry.firstName}</td>
                    <td className={customCSS.td}>{entry.lastName}</td>
                    <td className={customCSS.td}>{entry.email}</td>
                    <td className={customCSS.td}>{entry.phoneNumber}</td>
                    <td className={customCSS.td}>{entry.country}</td>
                    <td className={customCSS.td}>{entry.companyOrOrganization}</td>
                    <td className={customCSS.td}>{entry.comments}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className={customCSS.pagination}>
              {pageNumbers.map(number => (
                <button key={number} onClick={() => paginate(number)} className={customCSS.pageLink}>
                  {number}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contactforms;
